<template>
  <div class="container">
    <div class="preloader" v-if="!countItems">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <div class="main-wrapper">
      <h1 class="catalog-title">
        <span>{{ collectionName }}</span>
      </h1>

      <div class="catalog chess" v-if="countItems">
        <a
          href=""
          v-for="(item, index) in catalogItems"
          :key="index"
          :id="'link' + item.id"
          class="chess__item"
          @click.prevent="detail(item.id)"
        >
          <span class="chess__num">{{ item.number }}</span>
          <div
            class="chess__img"
            v-bind:style="{
              backgroundImage: 'url(' + item.previewPicture + ')',
            }"
          ></div>
          <p class="chess__discription">
            {{ item.name }}
          </p>
        </a>
      </div>
      <router-link
        tag="p"
        class="createOrder-btn"
        v-if="isCartNoEmpty"
        to="/order"
        >Перейти в корзину
      </router-link>
    </div>
  </div>
</template>
<script>
var VueScrollTo = require("vue-scrollto");
export default {
  data: () => ({
    catalogItems: [],
    collectionID: "",
    collectionName: "",
    dataLoaded: false,
    cetalogElementId: "", //Id элемента с которого был переход(для того, чтобы прокрутить каталог к нему)
  }),
  methods: {
    getProducts() {
      this.$store
        .dispatch("GET_CATALOG_LIST", this.collectionID)
        .then((response) => {
          this.catalogItems = response.data.data.products;
          this.collectionName = response.data.data.info.title;
          this.$localStorageSet("currentCollection", response.data.data);
          this.dataLoaded = true;
        })
    },
    detail(productId) {
      this.$router.push({
        path: "/catalog/" + this.collectionID + "/" + productId,
      });
    },
  },
  computed: {
    countItems: function () {
      return Object.keys(this.catalogItems).length;
    },
    isCartNoEmpty: function () {
      //Показать кнопку оформить заказ если в корзине что-то есть
      let miniCart = this.$localStorageGet("miniCart");
      return Object.keys(miniCart).length == 0 ? false : true;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.collectionID = vm.$route.params.id;
      vm.getProducts();
      from.params.element != undefined
        ? (vm.cetalogElementId = from.params.element)
        : (vm.cetalogElementId = "");
    });
  },
  watch: {
    dataLoaded: function (val) {
      if (val && this.cetalogElementId != "") {
        //Если в каталог перешли с карточки товара, прокрутить страницу до нужного элемента
        setTimeout(() => {
          VueScrollTo.scrollTo("#link" + this.cetalogElementId);
        }, 1);
      }
    },
  }
};
</script>
<style lang="scss">
  .createOrder-btn {
    width: 100%;
    border: 1px solid black;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 5px;
    background: #000;
    color: #fff;
    max-width: 340px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
</style>